import { PLACEHOLDER } from "constants/baseStyle";
import { HTTP_METHOD, POST_WITHDRAW_LIST } from "constants/pathConstant";
import { useMutationCustom } from "hooks/useMutationCustom";
import { useToastCustom } from "hooks/useToastCustom";
import { useEffect, useState } from "react";
import { Search, StateQuestion, Wrapper } from "template/SearchTemplate.style";
import stateJson from "../withdrawState.json";
import { dateFormat } from "components/dateFormat";
import { useOpenCustomModal } from "hooks/modal/useOpenCustomModal";
import ImgModal from "components/Modal/ImgModal";
import { getUserParamsFromUri } from "utils/crypto";

// 브릿지 -> 출금 :: 출금 관리 검색 (http://localhost:3000/super/bridge/withdraw)
export const WithdrawSearch = ({
  setWithdrawList,
  setPage,
  currentPage,
  pageSize,
  setSearchData,
  searchData,
  setIsSearch,
}) => {
  const toast = useToastCustom();
  const openStateModal = useOpenCustomModal(ImgModal);

  // const { id: mainId } = getUserParamsFromUri();

  const [id, setId] = useState("");
  const [useType, setUseType] = useState("");
  const [state, setState] = useState("");
  const [txId, setTxId] = useState("");
  const [acctUserNm, setAcctUserNm] = useState("");
  const [acctCd, setAcctCd] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [fromDt, setFromDt] = useState("");
  const [toDt, setToDt] = useState(
    dateFormat(new Date(), false, 0, 0).slice(0, 10)
  );

  const { mutate } = useMutationCustom(POST_WITHDRAW_LIST, HTTP_METHOD.POST);

  // page, size 바뀔때
  useEffect(() => {
    if (!Object.keys(searchData)[0]) return;

    const researchData = { ...searchData, pageSize, currentPage };

    mutate(researchData, {
      onSuccess: (data) => {
        setWithdrawList(data);
      },

      onError: () => {
        toast("데이터 조회 실패", "error");
      },
    });
  }, [currentPage, pageSize]);

  // useEffect(() => {
  //   if (mainId) {
  //     setIsSearch(true);
  //     fetchData(mainId);
  //   } else {
  //     fetchData();
  //   }
  // }, [mainId]);

  const fetchData = (mainId) => {
    const data = {
      id: mainId || id,
      useType,
      state,
      txId,
      acctUserNm,
      acctCd,
      cellNumber,
      fromDt: fromDt && dateFormat(fromDt, true),
      toDt: dateFormat(toDt, true, 1),
      pageSize,
      currentPage,
    };

    setSearchData(data);

    mutate(data, {
      onSuccess: (data) => {
        setWithdrawList(data);
      },
      onError: () => {
        toast("데이터 조회 실패, 검색값을 확인해주세요.", "error");
      },
    });
  };

  const handleSearch = () => {
    setPage(1);
    setIsSearch(true);
    fetchData();
  };

  const handleEnter = (key) => {
    if (key === "Enter") handleSearch();
  };

  const handleStateModal = () => {
    openStateModal({ src: "/file/9d5e42b4withdraw-proccess.png" });
  };

  return (
    <Wrapper>
      <Search.Text>
        <span>인출 검색</span>
        <StateQuestion onClick={handleStateModal}>?</StateQuestion>
      </Search.Text>
      <Search.Container style={{ gap: "11rem" }}>
        <Search.Content style={{ width: "100%" }}>
          {/* 번호 */}
          <Search.InputWrapper>
            <div>번호</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setId(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          {/* 회원명 */}
          <Search.InputWrapper>
            <div>회원명</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setAcctUserNm(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          {/* 회원코드 */}
          <Search.InputWrapper>
            <div>회원코드</div>
            <Search.Input
              placeholder={PLACEHOLDER.SOME}
              onChange={(e) => setAcctCd(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          {/* 전화번호 */}
          <Search.InputWrapper>
            <div>전화번호</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setCellNumber(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          {/* 구분 */}
          <Search.InputWrapper style={{ width: "15rem" }}>
            <div>유형</div>
            <Search.Select
              onChange={(e) => setUseType(e.target.value)}
              style={{ width: "13rem" }}
            >
              <Search.Option value="">{"전체"}</Search.Option>
              {Object.keys(stateJson.useType).map((v) => (
                <Search.Option key={v} value={v}>
                  {stateJson.useType[v]}
                </Search.Option>
              ))}
            </Search.Select>
          </Search.InputWrapper>

          {/* 상태 */}
          <Search.InputWrapper style={{ width: "14rem" }}>
            <div>상태</div>
            <Search.Select
              onChange={(e) => setState(e.target.value)}
              style={{ width: "12rem" }}
            >
              <Search.Option value="">{"전체"}</Search.Option>
              {Object.keys(stateJson.state).map((v) => (
                <Search.Option key={v} value={v}>
                  {stateJson.state[v]}
                </Search.Option>
              ))}
            </Search.Select>
          </Search.InputWrapper>

          {/* 지갑 주소 */}
          <Search.InputWrapper style={{ width: "38rem" }}>
            <div>txId</div>
            <Search.Input
              placeholder={PLACEHOLDER.SOME}
              onChange={(e) => setTxId(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          {/* 신청일자 */}
          <Search.InputWrapper style={{ padding: "0.5rem" }}>
            <div>신청일자 (부터)</div>
            <Search.Input
              type="date"
              defaultValue={fromDt}
              onChange={(e) => setFromDt(e.target.value)}
            ></Search.Input>
          </Search.InputWrapper>

          {/* 신청일자 */}
          <Search.InputWrapper style={{ padding: "0.5rem" }}>
            <div>신청일자 (까지)</div>
            <Search.Input
              type="date"
              defaultValue={toDt.slice(0, 10)}
              onChange={(e) => setToDt(e.target.value)}
            ></Search.Input>
          </Search.InputWrapper>
        </Search.Content>

        {/* 조회 버튼 */}
        <Search.Btn onClick={handleSearch}>조회</Search.Btn>
      </Search.Container>
    </Wrapper>
  );
};
